import React, { useContext, useEffect, useRef } from "react";

// SASS
import "./Part3.scss";

// COMPONENTS
import Step from "../Step/Step";

// CONTEXT
import BuildContext from "../../contexts/BuildContext/BuildContext";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import treeImg from "../../assets/img/tree-1.png";
import parkBackground from "../../assets/img/park-background-1.png";
import drop2Img from "../../assets/img/droplet-2.png";
import leafImg from "../../assets/img/green-leaf.svg";

export default function Part3({ step }) {
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "grow drop" },
    { stepNumber: "2", height: null, description: "hide outline" },
    { stepNumber: "3", height: null, description: "move drop" },
    { stepNumber: "4", height: null, description: "convert drop to leaf" },
    { stepNumber: "5", height: null, description: "spacer" },
  ];

  const dropEl = useRef(null);
  const dropContainerEl = useRef(null);
  const leafEl = useRef(null);

  const { buildEnv } = useContext(BuildContext);

  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ index, direction }) => {
        switch (index) {
          case 1: {
            animate.addClassOnEnter(dropEl.current, "grow", direction);
            break;
          }
          case 2: {
            animate.addClassOnEnter(
              dropContainerEl.current,
              "hidden",
              direction
            );
            break;
          }
          case 3: {
            animate.addClassOnEnter(dropEl.current, "moved", direction);
            break;
          }
          case 4: {
            animate.fadeOutOnEnter(dropEl.current, direction);
            animate.fadeInOnEnter(leafEl.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ index, progress }) => {
        switch (index) {
          // case 3:{
          //   moveDrop(progress);
          //   break;
          // }
          default:
            break;
        }
      })
      .onStepExit(({ index, direction }) => {
        switch (index) {
          case 1: {
            animate.removeClassOnExit(dropEl.current, "grow", direction);
            break;
          }
          case 2: {
            animate.removeClassOnExit(
              dropContainerEl.current,
              "hidden",
              direction
            );
            break;
          }
          case 3: {
            animate.removeClassOnExit(dropEl.current, "moved", direction);
            break;
          }
          case 4: {
            animate.fadeInOnExit(dropEl.current, direction);
            animate.fadeOutOnExit(leafEl.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  const showStepText = (buildEnv, text) => {
    if (buildEnv === "development") {
      return text;
    } else return null;
  };

  const moveDrop = (progress) => {
    const yPosition = progress * 37.5;
    const rotation = progress * -62;
    const transform = `translateY(${yPosition}rem) scale(2) rotate(${rotation}deg)`;
    dropEl.current.style.transform = transform;
  };

  return (
    <section className="wrapper one">
      <div className="sticky-container">
        <div className="part3">
          <div className="droplet-container">
            <div className="droplet-container__drop" ref={dropContainerEl}>
              <img src={drop2Img} alt="Drop" ref={dropEl} />
            </div>
            <div className="droplet-container__text">
              A lot of those droplets are big
            </div>
          </div>
          <div className="scene-container">
            <div className="scene-background">
              <img src={parkBackground} alt="Park" className="img-fluid" />
            </div>
            <div className="tree-img">
              <img src={treeImg} alt="Tree" className="img-fluid" />
            </div>
            <div className="middle-text-block">
              and don't travel far in the air.
            </div>
            <div className="ending-text-block">
              Instead, they fall towards the ground, like a leaf.
            </div>
            <div className="leaf-img" ref={leafEl}>
              <img src={leafImg} alt="Leaf" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
